import {
	Button,
	Card,
	Col,
	DatePicker,
	Form,
	Input,
	Row,
	Table,
	Typography,
} from "antd";

import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
	addSinglePublicHoliday,
	loadAllPublicHoliday,
} from "../../redux/rtk/features/publicHoliday/publicHolidaySlice";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

// Extend dayjs with the required plugins
dayjs.extend(utc);
dayjs.extend(timezone);

function CustomTable({ list, loading }) {
	const [columnsToShow, setColumnsToShow] = useState([]);

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			id: 2,
			title: "Name",
			dataIndex: "name",
			key: "name",
		},

		{
			id: 3,
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (date) => dayjs(date).format("DD/MM/YYYY"),
		},

		{
			id: 3,
			title: "Created At",
			dataIndex: "createdAt",
			key: "createdAt",
			render: (createdAt) => dayjs(createdAt).format("DD/MM/YYYY"),
		},
		{
			id: 4,
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id) => (
				<UserPrivateComponent permission={"readSingle-publicHoliday"}>
					<ViewBtn path={`/admin/holiday/public/${id}/`} />
				</UserPrivateComponent>
			),
		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));


	return (
		<Card>
			<div className='text-center my-2 flex justify-between'>
				<h5 className='department-list-title text-color-2 text-xl mb-2'>
					Public Holiday List
				</h5>
				{list && (
					<div>
						<CsvLinkBtn>
							<CSVLink
								data={list}
								className='btn btn-dark btn-sm mb-1'
								filename='public-holiday'>
								Download CSV
							</CSVLink>
						</CsvLinkBtn>
					</div>
				)}
			</div>

			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}

			<Table
				scroll={{ x: true }}
				loading={!list || loading}
				columns={columnsToShow}
				dataSource={list ? addKeys(list) : []}
			/>
		</Card>
	);
}

const AddPublicHoliday = ({ drawer }) => {
	const { list, loading } = useSelector((state) => state.publicHoliday);
	const [loader, setLoader] = useState(false);
	const [form] = Form.useForm();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(loadAllPublicHoliday());
	}, []);

	const { Title } = Typography;

	const onFinish = async (values) => {
		console.log(values)

		if (values.date) {
			const adjustedDate = dayjs(values.date).utc(true); // Convert to UTC and adjust time
			values.date = adjustedDate; // Set the adjusted date back to values
		}
		setLoader(true);
		const resp = await dispatch(addSinglePublicHoliday(values));

		if (resp.payload.message === "success") {
			setLoader(false);
			form.resetFields();
			dispatch(loadAllPublicHoliday());
		} else {
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding department");
		setLoader(false);
	};
	return (
		<UserPrivateComponent permission={"create-publicHoliday"}>
			<Row className="mr-top" justify="space-between" align="top" gutter={[16, 16]}>
				{/* Form Section */}
				<Col xs={24} sm={24} md={10} lg={10} xl={10} className="column-design border rounded card-custom">
					<Title level={4} className="m-2 text-center">Add Public Holiday</Title>
					<Form
						form={form}
						name="basic"
						onFinish={onFinish}
						onFinishFailed={onFinishFailed}
						autoComplete="off"
						layout="vertical"
					>
						<Form.Item 
							label="Name" 
							name="name" 
							rules={[{ required: true, message: "Please input name!" }]}
						>
							<Input placeholder="New Year" />
						</Form.Item>
	
						<Form.Item 
							label="Date" 
							name="date" 
							rules={[{ required: true, message: "Please input date!" }]}
						>
							<DatePicker placeholder="Select Date" style={{ width: "100%" }} />
						</Form.Item>
	
						<Form.Item>
							<Button
								onClick={() => setLoader(true)}
								type="primary"
								htmlType="submit"
								block
								loading={loader}
							>
								Add Public Holiday
							</Button>
						</Form.Item>
					</Form>
				</Col>
	
				{/* Table Section */}
				<UserPrivateComponent permission={"readAll-publicHoliday"}>
					<Col xs={24} sm={24} md={14} lg={14} xl={14}>
						<CustomTable list={list} loading={loading} />
					</Col>
				</UserPrivateComponent>
			</Row>
		</UserPrivateComponent>
	);
	

};

export default AddPublicHoliday;
